import * as Yup from 'yup';

export const tableSettingsSchema = Yup.object().shape({
  autoAssignIds: Yup.boolean().default(false),
  coordinatesVersion: Yup.string().oneOf(['lnglat', 'latlng']).default('latlng'),
  farmSizeUnit: Yup.string().oneOf(['ha', 'km2']).default('ha'),
}) as Yup.ObjectSchema;
